<template>
    <v-content>
      <v-container fluid>
        <h1 class="py-3">Device Data Export</h1>
        <h4>Complete the below form to select a device to Export, select All for all devices.</h4>
        <v-alert v-if="error" :value="true" type="error">
          {{ error }}
        </v-alert>
        <SelectDeviceForm  v-else v-on:validate="deviceSelected" allowAllDevices />
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <h2 class="pt-3" v-if="jsonData">Downloads</h2>
        <!-- Do DeviceType specific CSV Downloads
             If Decoder 'Codec' returns: key fields - Readings_Names[] and Alert_Names[]
        -->
        <DeviceTypeReportCSV v-if="jsonData" :data="jsonData" :readingsNames="jsonReadingsNames" :alertsNames="jsonAlertsNames" :deltas="jsonDeltas"/>
        <v-alert v-else-if="jsonData" :value="true" type="error">
          The device type ({{ typename }}) you selected is not currently supported by the Export API.
        </v-alert>

      </v-container>
    </v-content>
</template>

<script>
import moment from 'moment'
import SelectDeviceForm from '@/components/Common/SelectDeviceForm'
import DeviceTypeReportCSV from './DeviceTypeReportCSV'
export default {
  name: 'Export',
  components: { SelectDeviceForm, DeviceTypeReportCSV },
  data () {
    return {
      error: false,
      jsonData: null,
      jsonReadingsNames: null,
      jsonAlertsNames: null,
      jsonDeltas: null,
      typename: null,
      loading: false
    }
  },
  methods: {
    errorHandler (error) {
      // Inspect the error response.
      var errorStr = 'Request to backend failed.'
      if (error.response && error.response.data) {
        if (error.response.data.error) {
          errorStr = errorStr + ` Error: ${error.response.data.error}.`
        }
        if (error.response.data.message) {
          errorStr = errorStr + ` Message: ${error.response.data.message}.`
        }
        this.error = errorStr
      } else {
        this.error = errorStr + ' Please try again later.'
      }
    },
    deviceSelected (data) {
      this.loading = true
      // Format the dates properly.
      var dateFrom = moment(data.dateFrom, 'YYYY-MM-DD').format('YYYYMMDD000000')
      var dateTo = moment(data.dateTo, 'YYYY-MM-DD').format('YYYYMMDD235959')

      var url = null
      // Check if we need to export all devices in the DT.
      if (data.device.devicename === 'All') {
        url = `/schemas/devicetypeid_messages/${data.deviceType.id}`
      } else {
        url = `/schemas/devicename_messages/${data.device.devicename}`
      }
      // Handle the dates.
      if (dateFrom.length > 0) {
        url = url + `?datefrom=${dateFrom}`
        if (dateTo.length > 0) {
          url = url + `&dateto=${dateTo}`
        }
      }

      // Set the typename
      this.typename = data.deviceType.typename

      // Make the API request to get the messages for this device.
      this.$http.get(url)
        .then(response => {
          if (response.data && response.data.messages) {
            this.jsonData = response.data.messages
            this.jsonReadingsNames = response.data.readings_names
            this.jsonAlertsNames = response.data.alerts_names
            this.jsonDeltas = response.data.metrics.deltas
            this.loading = false
          }
        })
        .catch((error) => this.errorHandler(error))
    }
  }
}
</script>
